import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Gadget from './Gadget';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
    paddingBottom: theme.spacing(2),
  },
}));

const SingleColumnLayout = ({ gadgets }) => {
  return (
    <Grid container spacing={2} justifyContent="center">
      <Grid item xs="auto" style={{ width: 640 }} zeroMinWidth>
        <Grid container spacing={2} justifyContent="center">
          {gadgets.map((item) => (
            <Gadget
              key={item.id}
              gridSize={6}
              metric={item.metric}
              attributes={item.attributes}
            />
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
};

SingleColumnLayout.defaultProps = {
  gadgets: [],
};

SingleColumnLayout.propTypes = {
  gadgets: PropTypes.array,
};

const DoubleColumnLayout = ({ gadgets }) => {
  const halfLength = (gadgets.length / 2).toFixed();
  const leftGadgets = gadgets.slice(0, halfLength);
  const rightGadgets = gadgets.slice(halfLength);

  return (
    <Grid container spacing={8} justifyContent="center">
      <Grid item xs="auto" style={{ width: 640 }}>
        <Grid container spacing={2}>
          {leftGadgets.map((item) => (
            <Gadget
              key={item.id}
              metric={item.metric}
              attributes={item.attributes}
            />
          ))}
        </Grid>
      </Grid>
      <Grid item xs="auto" style={{ width: 640 }}>
        <Grid container spacing={2}>
          {rightGadgets.map((item) => (
            <Gadget
              key={item.id}
              metric={item.metric}
              attributes={item.attributes}
            />
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
};

DoubleColumnLayout.defaultProps = {
  gadgets: [],
};

DoubleColumnLayout.propTypes = {
  gadgets: PropTypes.array,
};

const Metrics = ({ gadgets }) => {
  const classes = useStyles();

  return (
    <Container className={classes.root}>
      {gadgets.length <= 4 ? (
        <SingleColumnLayout gadgets={gadgets} />
      ) : (
        <DoubleColumnLayout gadgets={gadgets} />
      )}
    </Container>
  );
};

Metrics.defaultProps = {
  gadgets: [],
};

Metrics.propTypes = {
  gadgets: PropTypes.array,
};

export default Metrics;
